import { render, staticRenderFns } from "./EditBlacklistCustom.vue?vue&type=template&id=6bb304a3&"
import script from "./EditBlacklistCustom.vue?vue&type=script&lang=js&"
export * from "./EditBlacklistCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports